module.exports = "/public/images/eabfc5bb14ea852c390a805cbe223a67.jpg";